export const userAccountModel = {
   'username': {
      'title': "Username",
      'display': true
   },
   'password': {
      'title': "Password",
      'display': false
   },
   'first_name': {
      'title': "First Name",
      'display': true
   },
   'last_name': {
      'title': "Last Name",
      'display': true
   }
};